import { rankList } from "@/mocks/homeData";
import type { RankItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function RankingList() {
  return (
    <section id="ranking" className="w-full px-4 py-20 md:px-8 md:py-28">
      <SectionHeading
        kicker="热门排行盘点"
        title="黑料网红排行：本期讨论度前十"
        desc="按近三十天的讨论度、评论量与二次传播热度综合排序，只做陈列，不做定论。
          排行每期更新，往期条目会归入合集继续留档。"
        side={
          <span className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2 font-label text-xs text-foreground-600">
            <i className="ri-fire-line text-primary-500" />
            更新于 09.12
          </span>
        }
      />

      <ol className="mt-12 md:mt-16">
        {rankList.map((item: RankItem) => (
          <li
            key={item.rank}
            className="group flex flex-col gap-4 border-b border-background-200 py-6 md:flex-row md:items-start md:gap-8 md:py-7"
          >
            <div className="flex items-center gap-4 md:w-28 md:shrink-0 md:flex-col md:items-start md:gap-2">
              <span className="font-heading text-3xl font-black text-primary-500 md:text-4xl">
                {item.rank}
              </span>
              <span className="inline-flex items-center rounded-full bg-secondary-100 px-2.5 py-0.5 font-label text-[11px] text-secondary-900">
                {item.tag}
              </span>
            </div>

            <div className="flex-1">
              <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                {item.title}
              </h3>
              <p className="mt-2 max-w-3xl text-[13px] leading-relaxed text-foreground-600 md:text-sm">
                {item.summary}
              </p>
            </div>

            <div className="flex items-center gap-6 md:w-56 md:shrink-0 md:flex-col md:items-end md:gap-3">
              <div className="w-full md:max-w-[180px]">
                <div className="mb-1.5 flex items-center justify-between font-label text-[11px] text-foreground-500">
                  <span>讨论度</span>
                  <span>{item.heat}</span>
                </div>
                <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <span
                    className="block h-full rounded-full bg-accent-500"
                    style={{ width: `${item.heat}%` }}
                  />
                </div>
              </div>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap font-label text-[11px] text-foreground-500">
                <i className="ri-chat-3-line" />
                {item.comments.toLocaleString()}
              </span>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}